import * as React from "react";

import { ExternalLink } from "./external-link";
import NextLink from "./next-link";
import type { NextLinkProps } from "./next-link";

export type LinkProps = Omit<
  React.AnchorHTMLAttributes<HTMLAnchorElement>,
  Exclude<keyof NextLinkProps, "href">
> &
  NextLinkProps & {
    children?: React.ReactNode;
  } & React.RefAttributes<HTMLAnchorElement> & { external?: boolean };

const Link = React.forwardRef<HTMLAnchorElement, LinkProps>(
  ({ className, href, external, ...props }, ref) => {
    const Comp = external ? ExternalLink : NextLink;
    const otherProps = external ? {} : { prefetch: false };
    return (
      <Comp
        href={href}
        className={className}
        ref={ref}
        prefetch={!external ? false : undefined}
        {...props}
        {...otherProps}
      />
    );
  }
);

Link.displayName = "Link";

export { Link };
